var _defs, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeedsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14",
    "data-name": "Group 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.812,
    height: 56.902,
    viewBox: "0 0 68.812 56.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3495",
    "data-name": "Rectangle 3495",
    width: 68.812,
    height: 56.902,
    fill: "#58c4df"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M2099.339,1431.7l-1.7.208-.136.407.125.589.45,3.414-.827.688-1.083,2.254-.542,1.293,2.009,1.027-.045.811,2.057,1.679,3.283-.1v-1.407l.339-1.186-1.339-1.988-1.052-4.339-1.022-1.156v-.586l.67-.268.177-1.417-.148.074Z",
    transform: "translate(-2046.975 -1398.395)",
    fill: "#58c4df"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M2003.62,673.1l-.113.714,1.174,1.174-1.491,2.143-2.876,1.573-3.8-.305v.738l1.39.738.218,1.088.557.214.345.906,1.678.272-.138,1.1.423.3.081.778,2.378.086.271.543v.582l-.709.576-.03.3,1.145.748-.095.712.128.351,1.383-.119.689-.646.844-.3,1.662,1.224.808-.383.609.183-.45,2.518,1.087,1.3.793.513v2.033l-.7,1.934-.087,5.812,1.2,1.486,1.211-.48h2.02l1.254-1.323-.07-.766.07-1.114.557-3.134,1.741-.975.209-.557-.557-1.672-3.831-6.059.209-3.2.627-1.95-.418-.7-1.393-1.184-.139-2.507-.836-.836-.836-2.507.091-.119-2.191.346-.728-1.047-2.99-1.16-.044-1.84-.1-.032Z",
    transform: "translate(-1950.167 -655.583)",
    fill: "#58c4df"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M761.837,757.188l-.266,2.308-1.013,1.14.305.474,1.294.223.369,1.065,1.592-.857,1.812-.216.724-.965-.082-1.274-1.182-1.839-.4-2.416-.129-2.705-.4-.323-3.377.079.166.142.486,1.855.76.849v.872Z",
    transform: "translate(-742.902 -734.35)",
    fill: "#58c4df"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M2297.776,1389.575v-1.832l-.7-.453-.013-.016-1.184-1.412.429-2.4-.269-.081-.862.408-1.677-1.235-.649.229-.717.672-1.473.126-.215,1.727-.648.259v.292l1,1.128,1.057,4.358,1.383,2.053-.364,1.273v1.36l.91-.027,1.554,1.006.448.672,1.56,1.617.848-.336-1.207-1.5.089-5.96Z",
    transform: "translate(-2236.643 -1350.458)",
    fill: "#58c4df"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M1345.259,0l-4.179,1.254-1.463,1.811-2.368.766-.627,2.716L1334.951,7.6l-2.159.07-4.04-1.741-.905-2.02-2.716-.348L1323.668,2.3h-1.114l-.975,1.114.766,4.457-1.944.181,1.2,1.03-.175,2.838L1326,14.538l-.884,1.722-.166,1.331.436.674.973.531.59,1.18,6.088-.82,1.95-.464.3.654-.856,1.441-.09.941-.42.421.049.22,5.874.472,2.746-1.5,1.321-1.9-1.11-1.11.151-.955,2.426-2.106.432.144.044,1.85,2.9,1.124.677.974,2.308-.364,1.055-1.371,2.368-1.184.488-2.716-1.115-3.9.279-1.045,2.02-1.88.139-1.532-1.393-2.716L1350.552.423Z",
    transform: "translate(-1289.75 -0.005)",
    fill: "#58c4df"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M797.012,534.04l-.127-.57.458-.458.086-.9.813-1.37-.142-.312-1.74.414-6.3.849-.64-1.28-.959-.523-.53-.819.185-1.48.785-1.529-4.345-2.489-.8.38-.223.891-1.118.34-2.4-.437-1.178.589.1.425.562.562.968.29-.134.626.7.281-.531.885-2.619-.587-2.311.385-.709.532.393.322.134,2.821.389,2.336,1.19,1.851.094,1.449-.857,1.143-1.878.224-1.585.854.02.057-1.059.092.043,2.921-.8.708-.027.321h1.11l.276,1.794.523.644,1.262.467-.423,2.115-.472.826c.255.285.568.667.568.667l-1.5,1.824-.089.042,10.235-.254,1.619,1.2.54,2.7.042.879.63.629-.22,1.1.456.456.182.654,3.3-1.862,2-.087.184-.184-.654-.872.615-.71.351-3.729,1.035-1.364,1.768.1.744,1.094h1.485l1.22-.407,3.717,1.9.538-1.283,1.111-2.311.755-.629-.428-3.257-.139-.647.216-.647,1.905-.231h1.153l.211-.106-.145-.4.081-.606-1.139-.745.058-.581.7-.566v-.384l-.168-.336-2.454-.089-.094-.892-.456-.319.125-1-1.572-.255-.358-.939-.585-.225-.222-1.108-1.421-.755v-.928Z",
    transform: "translate(-753.027 -511.415)",
    fill: "#58c4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M644.148,345.029l-.436.829.093.745-.909.606-1.065-.185-1.464-.244-.394,1.142-.041,2.155,2.254.638.764.651v-.006l3.689-.087.87-.652,2.432-.405,2.476.555.259-.432-.616-.246.129-.6-.789-.237-.668-.668-.165-.717,1.457-.729,2.428.442.9-.275.216-.866.908-.432.166-2.7-1.3-1.115-.664.062-1.741.836h-1.741l-1.323-1.045h-.836l-1.184,1.045-3.775.128Z",
    transform: "translate(-625.077 -334.099)",
    fill: "#58c4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M702.1,1767.71l-3.938-2.057.006-.012-.951.536-.258-.927-.51-.51.22-1.1-.6-.6-.046-.966-.514-2.573-1.456-1.082-10.777.268-.6.282-2.118,2.617,1,1.441,1.676.235,3.911,1.441v1.264l1.147,3.794,5.353-.088.559,1.235,1.966,2.061,1.741,1.532,1.114-1.741.7-.418.7.348.766-.209,1.6-4.171Z",
    transform: "translate(-664.762 -1717.604)",
    fill: "#58c4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M1476.384,1715.212l-.43-.645-1.433-.927-4.489.132-2.247-1.835.043-.771-5.709-2.919-1.152.384h-1.677l-.749-1.1-1.482-.08-.9,1.183-.352,3.738-.527.608.664.885-.431.431-2.041.089-2.326,1.312,3.816,1.993.635.559.03-.078,3.273,1.95,1.254-1.184,5.711.279,1.184.418,1.463-.348,4.527-.348,2.229-1.532,1.532-.209,1.081-.428Z",
    transform: "translate(-1417.461 -1667.813)",
    fill: "#58c4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M13.089,479.726l-1.15,2.078.963-.251,1.132-.647,1.066.025.867,1.289,1.492,1.053.942-1.06.261-2.26.656-1.574v-.71l-.734-.82-.481-1.835-1.129-.962-2.4-.68.046-2.413.425-1.233-.452-.754-4.864.091.023.1-.766.557-.348,1.114-1.045-.279-.836.905h-.7l-1.95-2.229-1.88-.209-1.811-.975L0,471.047l1.715.415.743,2.321.836,1.161.279,1.021,1.254.139,1.3-.7,1.393.511,4.039.418Z",
    transform: "translate(0 -457.187)",
    fill: "#58c4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M461.3,1047.656l1.235,1.265s2.529-1.118,2.618-1.118c.017,0,.059.035.116.091l.407-.713.368-1.838-1.11-.411-.619-.762-.251-1.632H462.89l.061-.733.785-.7-.045-3.053.961-.083-.31-.9-1.253-.216-.414-.643-1.614-1.139-.815-1.212-.844-.02-1.1.627-1.256.328-.1.186.279,1.578-.279,2.646-1.068,4.643H457.5l-.527,4.245Z",
    transform: "translate(-445.297 -1009.847)",
    fill: "#58c4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M352.552,281.225l5.082-.095.535.892,1.518.253.956.166.673-.449-.083-.661.442-.84-.068-1.745-.056,0-1.114-1.254-.905-.07-1.95.766-.905-.07-.348-1.95-2.855-.139V277.5l-.7.7H351.1l-.07,2.438,1.463.348Z",
    transform: "translate(-342.886 -269.625)",
    fill: "#58c4df"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeedsImg);
export default __webpack_public_path__ + "static/media/leeds-img.234461f3d4ccffdd8e0aacf73873c827.svg";
export { ForwardRef as ReactComponent };